$(document).ready(function(){
$('.responsive').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 2.2,
  slidesToScroll: 1,
    arrows:true,
     prevArrow:"<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0774/7511/9390/files/left.png?v=1711620681'>",
      nextArrow:"<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0774/7511/9390/files/right.png?v=1711620675'>",
 responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2.4,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2.4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2.4,
        slidesToScroll: 1
      }
    }
   
  ]
});
});